import React from "react";

import "./CheckoutError.scss";

const CheckoutError = () => (
  <section className="checkout-error">
    <div className="checkout-error__header">
      <div className="elipse elipse--red">
        <svg
          className="elipse__tick-mark"
          viewBox="0 0 14 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.40234 6.91086L3.68382 9.1029C3.91488 9.32491 4.2811 9.32124 4.50768 9.09466L12.6023 1"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <p className="checkout-error__header__title">Ups!</p>
      <p className="checkout-error__header__label">
        No se ha podido procesar tu pedido. Inténtalo de nuevo más tarde o ponte
        en contacto con nosotros para poder ayudarte.
      </p>
    </div>
    <p className="checkout-error__copy">
      También puedes enviarnos tu pedido manualmente por whatsapp o email.
    </p>
  </section>
);

export default CheckoutError;
